import { useLiveMessage } from './liveRegionStore';

/**
 * The single polite live region for ambient builder announcements (build-plan §7.7) — device-preview
 * changes, preview-mode toggle, selection moves. dnd already has its OWN announcer (the dnd-kit
 * announcements API), and save-state has its own `role=status`; this covers the rest so a screen-reader
 * user hears non-visual state changes. Visually hidden (`bld-sr-only`), `aria-live="polite"`.
 */
export function LiveRegion() {
  const message = useLiveMessage();
  return (
    <div className="bld-sr-only" role="status" aria-live="polite" aria-atomic="true">
      {message}
    </div>
  );
}
